<p-toast></p-toast>

<ng-container *ngIf="display === 'dialog'">
    <!-- Button to open the list -->
    <button pButton label="Approvals" type="button" (click)="showListDialog()" icon="pi pi-list-check" class="mr-2"
        style="position: relative;" severity="success">
        <p-badge [value]="getPendingApprovalCount()" severity="danger"
            [style]="{'position': 'absolute', 'top': '0', 'right': '0'}"></p-badge>
    </button>

    <!-- Main Dialog for listing approvals -->
    <p-dialog [(visible)]="listDialogVisible" [modal]="true" [style]="{width: '60vw'}" [draggable]="false"
        [resizable]="false">
        <ng-template pTemplate="header">
            <div class="flex align-items-center justify-content-between w-full">
                <div class="flex align-items-center">
                    <i class="pi pi-list-check text-2xl mr-2"></i>
                    <h3 class="m-0">Pending Approvals</h3>
                    <p-badge [value]="getPendingApprovalCount()" severity="danger" class="ml-2"></p-badge>
                </div>
                <div class="flex align-items-center gap-2">
                    <p-selectButton [options]="filterOptions" [(ngModel)]="filter" optionLabel="label"
                        optionValue="value" (onChange)="reload()"></p-selectButton>
                    <button pButton pRipple type="button" icon="pi pi-refresh" class="p-button-text p-button-sm"
                        (click)="reload()" [loading]="loading"></button>
                </div>
            </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="approvalContent"></ng-container>
        <ng-template pTemplate="footer">
            <p-button icon="pi pi-times" (click)="listDialogVisible = false" label="Close"
                styleClass="p-button-text"></p-button>
        </ng-template>
    </p-dialog>
</ng-container>

<div class="card" *ngIf="display === 'inline'">
    <div class="flex align-items-center justify-content-between w-full mb-3">
        <div class="flex align-items-center">
            <i class="pi pi-list-check text-2xl mr-2"></i>
            <h3 class="m-0">Pending Approvals</h3>
            <p-badge [value]="getPendingApprovalCount()" severity="danger" class="ml-2"
                *ngIf="getPendingApprovalCount() > 0"></p-badge>
        </div>
        <div class="flex align-items-center gap-2">
            <p-selectButton [options]="filterOptions" [(ngModel)]="filter" optionLabel="label"
                        optionValue="value" (onChange)="reload()"></p-selectButton>
            <button pButton pRipple type="button" icon="pi pi-refresh" class="p-button-text p-button-sm"
                (click)="loadPendingApprovals()" [loading]="loading"></button>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="approvalContent"></ng-container>
</div>

<ng-template #approvalContent>
    <p-table [value]="pendingApprovals" [loading]="loading" [lazy]="true" [paginator]="true" [rows]="pageSize"
        [first]="currentFirst" [totalRecords]="totalRecords" (onLazyLoad)="onLazyLoad($event)"
        styleClass="p-datatable-sm p-datatable-striped" responsiveLayout="scroll">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 6rem">Action</th>
                <th>Reference</th>
                <th>Status</th>
                <th>Requested On</th>
                <th>Comments</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-approval>
            <tr>
                <td>
                    <button pButton pRipple type="button" icon="pi pi-window-maximize" class="p-button-rounded p-button-text"
                        (click)="navigateToItem(approval)"></button>
                </td>
                <td>{{ approval.resourceType?.resourceName }} #{{ approval.businessObjectId }}</td>
                <td>
                    <div class="flex flex-wrap gap-2">
                        <span *ngFor="let step of approval.pendingSteps"
                              [ngClass]="{
                                'text-green-500 font-bold': getSeverityForStatus(step) === 'success',
                                'text-red-500 font-bold': getSeverityForStatus(step) === 'danger'
                              }">
                            {{ step.workflowStatus?.statusName }}
                        </span>
                    </div>
                </td>
                <td>{{ approval.requestedOn | appDate:'medium' }}</td>
                <td>{{ approval.comments }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center p-4">No pending approvals found.</td>
            </tr>
        </ng-template>
    </p-table>
</ng-template>
